module.exports = __webpack_public_path__ + "img/1514834317.cf4a087b.jpg";